
// import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton } from '@mui/material';
// import React, { useEffect, useState } from 'react';

// import AppModal from "../../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../..//components/inverter/InvverterFullSize";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../../assets/img/logos/logo 2.png';
// import "./EnergyMeterTab2.css"

// import RefreshIcon from '@mui/icons-material/Refresh';
// import { EnergyMeterTab2LogApi } from '../../../../../../api/Api';



// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
//     const tenDaysAgo = new Date(date);
//     tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
//     const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

//     return {
//         Today: formattedCurrentDate,
//         LastDay: formattedTenDaysAgo,
//     };
// }
// function EnergyMeterTab2({ ID, TabTitle }) {
//     const now = new Date();
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const { palette, spacing, shape: { borderRadius } } = useTheme()
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(12);


//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     // Fetch data dynamically based on updated StartDate, EndDate, and ID
//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         const credentials = {
//             LOGIN_ID: sessionStorage.getItem("LoginID") || "",
//             PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
//             LCODE: sessionStorage.getItem("LCODE"),
//             WEB_KEY: "xyz",
//             DT1: StartDate,
//             DT2: EndDate,
//             FID: ID
//         };

//         // console.log("data pram4 credentials:", credentials);

//         try {
//             const res = await EnergyMeterTab2LogApi(credentials);
//             if (res?.LOG && Array.isArray(res.LOG)) {
//                 setLogData(res.LOG);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };




//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     // Get table headers from the first item in logData (dynamically)
//     const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

//     // Export to Excel
//     const exportToExcel = () => {
//         const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, `Daily Curtailment`);
//         XLSX.writeFile(wb, `${TabTitle} To  Log ${EndDate.replace(" ", "T")}`);
//     };

//     // Export to PDF
//     const exportToPDF = () => {
//         const doc = new jsPDF();

//         // Add Logo (x, y, width, height)
//         const imgWidth = 30;  // Adjust width
//         const imgHeight = 20; // Adjust height
//         const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
//         doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

//         // Add Title or Text Below the Logo
//         const title = `${TabTitle} To  Log ${EndDate.replace(" ", "T")}`;
//         doc.setFontSize(12);  // Adjust font size
//         doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

//         // Adjust Y position for the table to start below the text
//         let startY = 50;  // Push table further down below text

//         doc.autoTable({
//             head: [tableHeaders],
//             body: logData.map((item) => tableHeaders.map((key) => item[key])),
//             startY: startY,  // Start table below the logo and text
//             theme: "grid",
//         });

//         doc.save(`${TabTitle} To  Log ${EndDate.replace(" ", "T")}`);
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [ID]);

//     // Refresh data only when clicking "Show"
//     function onRefreshData() {
//         if (StartDate.length !== 0 && EndDate.length !== 0) {
//             fetchLogData(); // Fetch data only after clicking the button
//         } else {
//             alert("Please provide valid dates");
//         }
//     }

//     const handleStartDateChange = (value) => {
//         setStartDate(value); // Update the StartDate directly
//     };

//     // Handle End Date change
//     const handleEndDateChange = (value) => {
//         setEndDate(value); // Update the EndDate directly
//     };


//     console.log("EnergyID", ID)

//     return (
//         <>
//             <CssBaseline />
//             <Box bgcolor={'background.default'} py={spacing(1)}>

//                 <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: .4 }}>
//                     <Grid key="chart-grid" item xs={12}>
//                         <Card>
//                             <CardActions sx={{
//                                 display: "flex",
//                                 justifyContent: "flex-end",
//                                 alignItems: "center",
//                                 gap: "16px",
//                             }}>
//                                 <label>

//                                     <input
//                                         type="date"
//                                         value={StartDate} // Use StartDate directly
//                                         onChange={(e) => handleStartDateChange(e.target.value)}
//                                         style={{
//                                             padding: "2px 2px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>
//                                 <label>
//                                     To
//                                     <input
//                                         type="date"
//                                         value={EndDate} // Use EndDate directly
//                                         onChange={(e) => handleEndDateChange(e.target.value)}
//                                         style={{
//                                             padding: "2px 2px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>

//                                 <IconButton
//                                     onClick={onRefreshData}
//                                     sx={{
//                                         color: 'black',
//                                         // backgroundColor: palette.tintBlue,
//                                         borderRadius: borderRadius,
//                                         p: 1, // Adjust padding if needed
//                                     }}
//                                 >
//                                     <RefreshIcon sx={{ fontSize: '24px' }} />
//                                 </IconButton>

//                             </CardActions>
//                         </Card>
//                     </Grid>
//                 </Grid>

//                 <div style={{ padding: "4px", marginTop: ".4rem" }}>
//                     <div className="row">
//                         <div className="col-md-12">
//                             <div className="container-style">
//                                 <p className='responsiveHeaderStyle'></p>
//                                 <div className='responsiveControlsStyle'>
//                                     <button onClick={onRefreshData} className='button-style' >Show</button>
//                                     <button onClick={exportToExcel} className='export-button' >Excel</button>
//                                     <button onClick={exportToPDF} className='export-button2' >PDF</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="table-responsive">
//                         <table className="table table-hover table-bordered">
//                             <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
//                                 <tr>
//                                     {tableHeaders.map((header, index) => (
//                                         <th key={index} className='table-heading'>{header}</th>
//                                     ))}
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {loading ? (
//                                     <tr>
//                                         <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
//                                     </tr>
//                                 ) : currentData.length > 0 ? (
//                                     currentData.map((item, rowIndex) => (
//                                         <tr key={rowIndex}>
//                                             {tableHeaders.map((key, index) => (
//                                                 // <td key={index} className="text-center align-middle" style={tableBody}>
//                                                 //     {item[key] || ""}
//                                                 // </td>
//                                                 <td key={index} className="text-center align-middle table-body">
//                                                     {item[key] ?? ""}
//                                                 </td>

//                                             ))}
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan={tableHeaders.length} className="text-center">No data available</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     {/* Pagination */}
//                     <div style={{ textAlign: "right", marginTop: "10px" }}>
//                         <button
//                             onClick={() => handlePageChange(currentPage - 1)}
//                             disabled={currentPage === 1}
//                             className='pagination-button'
//                         >
//                             Previous
//                         </button>
//                         {[...Array(totalPages)].map((_, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => handlePageChange(index + 1)}
//                                 style={{

//                                     backgroundColor: currentPage === index + 1 ? "#356E35" : "#356E35",
//                                     color: currentPage === index + 1 ? "#fff" : "#fff",
//                                 }}
//                                 className='pagination-button'
//                             >
//                                 {index + 1}
//                             </button>
//                         ))}
//                         <button
//                             onClick={() => handlePageChange(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                             className='pagination-button'
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>

//             </Box>
//         </>
//     );
// }

// export default EnergyMeterTab2;



import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import AppModal from "../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../..//components/inverter/InvverterFullSize";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../../assets/img/logos/logo 2.png';
import "./EnergyMeterTab2.css"

import RefreshIcon from '@mui/icons-material/Refresh';
import { EnergyMeterTab2LogApi } from '../../../../../../api/Api';
import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../api/AxiosApi'
import { AuthenticationContext } from '../../../../../../context/AuthenticationContext';
import ExportExcel from '../../../../../../components/exportExcel/ExportExcel1';
import ExportPdf from '../../../../../../components/exportPdf/ExportPdf';

// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}
function EnergyMeterTab2({ ID, TabTitle }) {
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const now = new Date();
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(12);


    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID") || "",
        PASS_KEY: sessionStorage.getItem("PASS_KEY") || "xyz",
        LCODE: sessionStorage.getItem("LCODE"),
        WEB_KEY: "xyz",
        DT1: StartDate,
        DT2: EndDate,
        FID: ID
    };
    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        // console.log("data pram4 credentials:", credentials);

        try {
            const res = await EnergyMeterTab2LogApi(credentials);
            if (res?.LOG && Array.isArray(res.LOG)) {
                setLogData(res.LOG);
            } else {
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };


const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LCODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Get table headers from the first item in logData (dynamically)
    const tableHeaders = logData.length > 0 ? Object.keys(logData[0]) : [];

    // Export to Excel
    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(logData); // Directly use the full logData
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, `Daily Curtailment`);
    //     // XLSX.writeFile(wb, `${TabTitle} To  Log ${EndDate.replace(" ", "T")}`);
    //     const fileName = `${TabTitle}To  Log${EndDate.replace(/\s+/g, 'T')}.xlsx`;
    //     XLSX.writeFile(wb, fileName);
    // };

    const exportToExcel = async () => {
        await ExportExcel(
            ImageUrl,
            logData,
            StartDate,
            EndDate,
            `${TabTitle}_Log`,
            LoggedInUserInfo
        );
    };

    // Export to PDF
    // const exportToPDF = () => {
    //     const doc = new jsPDF();

    //     // Add Logo (x, y, width, height)
    //     const imgWidth = 30;  // Adjust width
    //     const imgHeight = 20; // Adjust height
    //     const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
    //     doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

    //     // Add Title or Text Below the Logo
    //     const title = `${TabTitle} To  Log ${EndDate.replace(" ", "T")}`;
    //     doc.setFontSize(12);  // Adjust font size
    //     doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

    //     // Adjust Y position for the table to start below the text
    //     let startY = 50;  // Push table further down below text

    //     doc.autoTable({
    //         head: [tableHeaders],
    //         body: logData.map((item) => tableHeaders.map((key) => item[key])),
    //         startY: startY,  // Start table below the logo and text
    //         theme: "grid",
    //     });

    //     doc.save(`${TabTitle} To  Log ${EndDate.replace(" ", "T")}`);
    // };


    const exportToPDF = async () => {
        await ExportPdf(
            ImageUrl,
            currentData,
            StartDate,
            EndDate,
            `${TabTitle}_Log`,
            LoggedInUserInfo,
            logo,
            tableHeaders

        );
    };

    useEffect(() => {
        fetchLogData();
    }, [ID]);

    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };


    // console.log("EnergyID", ID)

    return (
        <>
            <Grid container style={{ padding: "0", margin: "0" }}>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden' }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >

                            <div>

                                <div style={{
                                    marginBottom: "5px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "16px",
                                }}>
                                    {/* Left-side title */}
                                    <div style={{ marginLeft: "7px", fontSize: "14px" }}>
                                        Log ({TabTitle})
                                    </div>

                                    {/* Right-side date pickers */}
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        <label>
                                            From:&nbsp;
                                            <input
                                                type="date"
                                                value={StartDate} // Use StartDate directly
                                                onChange={(e) => handleStartDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 2px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>
                                        <label>
                                            To:&nbsp;
                                            <input
                                                type="date"
                                                value={EndDate} // Use EndDate directly
                                                onChange={(e) => handleEndDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 2px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>

                                        <button onClick={onRefreshData} className='button-style' >Show</button>
                                        <button onClick={exportToExcel} className='export-button' >Excel</button>
                                        <button onClick={exportToPDF} className='export-button2' >PDF</button>



                                    </div>
                                </div>



                                <div style={{ padding: "4px", marginTop: ".4rem" }}>


                                    <div className="table-responsive">
                                        <table className="table table-hover table-bordered">
                                            <thead className="text-center" style={{ backgroundColor: "rgb(253, 248, 228)" }}>
                                                <tr>
                                                    {tableHeaders.map((header, index) => (
                                                        <th key={index} className='table-heading' style={{ color: "#356E35" }}>{header}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
                                                    </tr>
                                                ) : currentData.length > 0 ? (
                                                    currentData.map((item, rowIndex) => (
                                                        <tr key={rowIndex}>
                                                            {tableHeaders.map((key, index) => (
                                                                // <td key={index} className="text-center align-middle" style={tableBody}>
                                                                //     {item[key] || ""}
                                                                // </td>
                                                                <td key={index} className="text-center align-middle table-body">
                                                                    {item[key] ?? ""}
                                                                </td>

                                                            ))}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={tableHeaders.length} className="text-center">No data available</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Pagination */}
                                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                className='pagination-button'
                                            >
                                                Previous
                                            </button>

                                            {[...Array(totalPages)].map((_, index) => {
                                                const isActive = currentPage === index + 1;
                                                return (
                                                    <button
                                                    className='pagination-button'
                                                        key={index}
                                                        onClick={() => handlePageChange(index + 1)}
                                                        style={{
                                                            backgroundColor: isActive ? "#356E35" : "white",
                                                            color: isActive ? "#fff" : "#356E35",
                                                        }}
                                                    >
                                                        {index + 1}
                                                    </button>
                                                );
                                            })}

                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                className='pagination-button'
                                            >
                                                Next
                                            </button>
                                        </div>
                                </div>



                            </div>
                        </Stack>


                    </Stack>


                </Grid>

            </Grid>
        </>
    );
}

export default EnergyMeterTab2;